import React from 'react'

const BookIcon = (props) => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" className={props.className}
    width="64.000000pt" height="64.000000pt"  viewBox="0 0 64.000000 64.000000"
    preserveAspectRatio="xMidYMid meet">

    <g  className={props.className} transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
    <path d="M442 570 c-22 -16 -58 -54 -79 -84 -21 -30 -42 -55 -47 -56 -4 0 -21
    11 -37 24 -35 30 -120 63 -174 67 -37 4 -40 2 -43 -23 -2 -16 -9 -28 -18 -28
    -8 0 -14 -9 -14 -20 0 -11 -7 -23 -15 -26 -13 -5 -15 -36 -15 -195 l0 -189
    320 0 320 0 0 190 0 190 -24 0 c-23 0 -25 4 -28 53 l-3 52 -42 -3 -43 -4 0 36
    c0 19 -4 37 -9 40 -5 3 -27 -8 -49 -24z m38 -169 l0 -170 -42 -31 c-24 -17
    -56 -49 -73 -71 l-30 -41 -3 161 c-2 131 0 167 13 192 20 37 107 129 123 129
    9 0 12 -46 12 -169z m-265 74 c100 -50 96 -40 93 -234 l-3 -170 -52 33 c-29
    18 -80 39 -113 46 l-60 13 0 175 0 175 43 -7 c23 -4 65 -18 92 -31z m365 -138
    l0 -173 -58 -12 c-33 -7 -81 -23 -107 -37 -27 -13 -50 -23 -52 -21 -7 7 54 74
    94 104 l43 33 0 134 c0 144 -1 141 58 144 l22 1 0 -173z m-520 -35 l0 -148 72
    -17 c39 -9 76 -22 82 -28 8 -8 5 -9 -12 -4 -13 4 -53 8 -90 10 l-67 3 -3 166
    c-2 108 1 166 8 166 6 0 10 -54 10 -148z m565 -73 l0 -174 -139 -3 c-126 -2
    -138 -1 -126 13 25 31 111 66 193 80 l37 6 0 123 c0 67 3 126 7 130 23 22 28
    -11 28 -175z m-595 21 l0 -150 67 0 c69 0 183 -26 183 -42 0 -5 -59 -7 -133
    -6 l-132 3 -3 173 c-2 112 1 172 8 172 6 0 10 -54 10 -150z"/>
    </g>
    </svg>
  )
}
export default BookIcon;
